// extracted by mini-css-extract-plugin
export var actionButton = "_ms-0";
export var actionMenuContainer = "_ms-i";
export var bubble = "_ms-2";
export var bubbleActionMenu = "_ms-j";
export var bubbleContext = "_ms-6";
export var bubbleItems = "_ms-7";
export var customer = "_ms-3";
export var divider = "_ms-8";
export var fileList = "_ms-9";
export var hiddenComment = "_ms-o";
export var infoAbove = "_ms-a";
export var internal = "_ms-4";
export var lightActionButton = "_ms-1";
export var link = "_ms-b";
export var merchant = "_ms-5";
export var message = "_ms-c";
export var profilePicture = "_ms-e";
export var quillToolbarContainer = "_ms-f";
export var senderDate = "_ms-g";
export var senderDateCustomer = "_ms-h";
export var senderName = "_ms-d";
export var time = "_ms-k";
export var uploadedImage = "_ms-l";
export var username = "_ms-m";
export var xsmall = "_ms-n";